<app-vvr-icon [dark]="false" [full]="false" [overlay]="false" [shadow]="false"></app-vvr-icon>
<div class="container">
    <div class="topbar">
        <div class="title">
            <h1 class="h3 condensed">Nieuws</h1>
        </div>
        <div class="controls">
            <div
                class="fab small"
                id="btn-Exit"
                matTooltip="Terug naar overzicht"
                matTooltipPosition="below"
                routerLink="/">
                <i class="fas fa-sign-out-alt"></i>
            </div>
        </div>
    </div>
</div>
<div class="items">
    @if (articles().length === 0 && !loading()) {
        <div class="not-found">
            <div class="text-center">
                Er zijn nog geen nieuwsberichten geplaatst
            </div>
        </div>
    }
    <virtual-scroller #virtualScroll (vsEnd)="scroll($event)" class="item-list">
        @for (article of articles(); track article.id) {
            <div class="item" routerLink="/{{Routenames.articles}}/{{article.slug}}">
                <app-codalt-image
                    [path]="article.id + '/' + article.image"
                    [thumb]="article.image_thumb"
                    class="detail__image">
                </app-codalt-image>
                <div [class.important]="article.alert" class="detail__block">
                    <h3 [class.unread]="!article.read" class="item__title">{{ article.title }}</h3>
                    <div class="details">
                        <time>
                            {{ article.publish_date | date:'EE d MMM yyyy HH:mm' }}
                        </time>
                        <div>{{ article.user.name }}
                            @for (classroom of article.classrooms; track classroom; let last = $last; let first = $first) {
                                {{ first ? ' | ' : '' }} {{ classroom.classroom_name }}{{ last ? '' : ',' }}
                            }
                        </div>
                    </div>
                </div>
            </div>
        }
        <div class="item-spacer"></div>
    </virtual-scroller>
    @if (AuthorisationService.hasFeature('createArticle')) {
        <button
            class="add-floating-button"
            color="primary"
            mat-fab
            routerLink="/{{Routenames.articles}}/nieuw/bewerken">
            <mat-icon class="fas fa-plus"></mat-icon>
        </button>
    }
    @if (AuthorisationService.hasFeature('createArticle')) {
        <button
            class="delete-button"
            color="primary"
            mat-fab
            matTooltip="{{future() ? 'Nieuws uit het verleden' : 'Toekomstig nieuws'}}"
            matTooltipPosition="before"
            routerLink="/{{Routenames.articles}}/{{future() ? '' : 'toekomst'}}">
            <mat-icon [class.fa-clock]="!future()" [class.fa-history]="future()" class="fas"></mat-icon>
        </button>
    }
</div>
<div [class.active]="childActive()" class="router-outlet">
    <router-outlet
        (activate)="childActive.set(true)"
        (deactivate)="childClosed($event); childActive.set(false)">
    </router-outlet>
</div>
